// extracted by mini-css-extract-plugin
export default {"logo":"MainPage_logo__hvaxo","panel":"MainPage_panel__Cu6PA","spotifyText":"MainPage_spotifyText__nuQvV"};